// EditSectionLocation — Section 2 of editRealty.
// Substrate: design/editRealty.html lines 364-428 — `<section id="sec-location">`.
//
// Structured C1 Location writes via shared D1 controls. Legacy
// country/region/city/district/address remain backend compatibility
// fields and are not identity editors here.

import LocationCanonicalFields, {
  CanonicalHierarchySummary,
} from "../../geo/widgets/LocationCanonicalFields";
import LocationStructuredAddressFields from "../../geo/widgets/LocationStructuredAddressFields";
import LegacyLocationUpgradeNotice from "../../geo/widgets/LegacyLocationUpgradeNotice";
import MapLinkCoordinatesImport from "../../geo/widgets/MapLinkCoordinatesImport";
import "../../geo/widgets/geoLocationFields.css";

function EditSectionLocation({ propertyId, values, onChange, fieldErrors = {} }) {
  const setField = (key, value) => onChange({ ...values, [key]: value });

  const handleCoordinatesImported = ({ latitude, longitude }) => {
    onChange({ ...values, latitude, longitude });
  };

  return (
    <section
      id="sec-location"
      className="ap-pane"
      aria-labelledby="ap-pane-location"
    >
      <header className="ap-pane__head">
        <h2 id="ap-pane-location">
          <i className="fa-solid fa-location-dot" aria-hidden="true" />
          Локація
        </h2>
        <p>Координати ставлять пін на карті в публічному перегляді.</p>
      </header>

      <LegacyLocationUpgradeNotice
        propertyId={propertyId}
        location={values}
        variant="full"
      />

      <div className="ap-row ap-row--2">
        <div className="ap-field">
          <div
            className="geo-country-context"
            data-testid="geo-country-context"
          >
            <span className="geo-country-context__label" id="edit-loc-country-label">
              Країна
            </span>
            <p
              className="geo-country-context__value"
              aria-labelledby="edit-loc-country-label"
            >
              Україна
            </p>
          </div>
          {fieldErrors.country ? (
            <small className="form-hint text-danger">
              {fieldErrors.country}
            </small>
          ) : null}
        </div>
      </div>

      <LocationCanonicalFields
        values={values}
        onChange={onChange}
        fieldErrors={fieldErrors}
        idPrefix="edit-loc"
      />

      <LocationStructuredAddressFields
        values={values}
        onChange={onChange}
        fieldErrors={fieldErrors}
        idPrefix="edit-loc"
      />

      {values.selectedSettlement ? (
        <CanonicalHierarchySummary
          unit={values.selectedSettlement}
          idPrefix="edit-loc"
        />
      ) : null}

      <MapLinkCoordinatesImport
        idPrefix="edit-loc"
        onCoordinatesImported={handleCoordinatesImported}
      />

      <div className="ap-row ap-row--2">
        <div className="ap-field">
          <label htmlFor="loc-lat">Широта</label>
          <input
            id="loc-lat"
            name="latitude"
            type="number"
            step="0.000001"
            className="form-control"
            value={values.latitude ?? ""}
            onChange={(e) => setField("latitude", e.target.value)}
          />
          {fieldErrors.latitude ? (
            <small className="form-hint text-danger">
              {fieldErrors.latitude}
            </small>
          ) : null}
        </div>
        <div className="ap-field">
          <label htmlFor="loc-lng">Довгота</label>
          <input
            id="loc-lng"
            name="longitude"
            type="number"
            step="0.000001"
            className="form-control"
            value={values.longitude ?? ""}
            onChange={(e) => setField("longitude", e.target.value)}
          />
          {fieldErrors.longitude ? (
            <small className="form-hint text-danger">
              {fieldErrors.longitude}
            </small>
          ) : null}
        </div>
      </div>

      <p className="ap-helper">
        <i className="fa-solid fa-circle-info" aria-hidden="true" />
        Не знаєте координати?{" "}
        <a
          href="https://www.openstreetmap.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Знайти на OpenStreetMap
          <i
            className="fa-solid fa-up-right-from-square"
            aria-hidden="true"
          />
        </a>
      </p>
    </section>
  );
}

export default EditSectionLocation;
